import { initializeSentry } from '../utils/sentry/intialize';

import React, { Suspense } from "react";
import * as Sentry from "@sentry/react";

import EnvironmentProvider from "@/api/common/contexts/EnvironmentProvider"
import { CheckoutProps } from "@/widgets/checkout/Checkout"
import { useSharedCrossWidgetComm } from '@/widgets/hooks/useSharedCrossWidgetComm';
import { EVENTS } from '@/utils/events/events';
import { getSubscriptionCode } from '@/utils/env';
import { Drawer } from '@n3oltd/n3o-ui-components';
import { LoadingOverlay } from '@/Loader';

const Checkout = React.lazy(() => import("@/widgets/checkout"));

const subscriptionId = getSubscriptionCode();

export const CheckoutElementWrapper = ({legacy, open, onClose}: CheckoutProps) => {
  const [cartOpen, setCartOpen] = React.useState<boolean>(open);
  const [hasPayitHash, setHasPayitHash] = React.useState<boolean>(false);
  const widgetRef = React.useRef<HTMLDivElement>(null);
  
  const eventBus = useSharedCrossWidgetComm({
    debug: import.meta.env.DEV,
  });

  React.useEffect(() => {
    const unsubscibeOpen = eventBus.on(EVENTS.CHECKOUT.checkoutOpen, () => {
      setCartOpen(true);
    });
    
    const unsubscibeClose = eventBus.on(EVENTS.CHECKOUT.checkoutClose, () => {
      setCartOpen(false);
    });

    return () => {
      unsubscibeOpen();
      unsubscibeClose();  
    } 
  }, [eventBus]);

  React.useEffect(() => {
    if (widgetRef.current) {
      initializeSentry(widgetRef.current);
    }

    Sentry.setContext("checkoutWidget", {
      version: "1.0.0",
      mode: "embedded",
      subscriptionId: subscriptionId,
    });
        
  }, []);
  
  React.useEffect(() => {
    const payitHash = '#n3o/elements/callback/payit'
    const url = window.location.href;
    const hasPayitHash = url.includes(payitHash);

    if (hasPayitHash) {
      setCartOpen(true);
      setHasPayitHash(true);
    }

  }, []);

  React.useEffect(() => {
    setCartOpen(open);
  }, [open]);
  
  const handleClose = () => {
    setCartOpen(false);
    onClose?.();
  }

  if(!cartOpen){
    return null;
  }

  return (
    <div ref={widgetRef}>
      <Sentry.ErrorBoundary>
        <EnvironmentProvider environment={import.meta.env.VITE_ENVIRONMENT}>
          <Suspense fallback={<Drawer
                    open={cartOpen}
                  >
                   <LoadingOverlay isLoading={true} /> 
                  </Drawer>}>
            <Checkout
              subscriptionId={subscriptionId}
              open={cartOpen}
              onClose={handleClose}
              legacy={legacy}
              hasPayitHash={hasPayitHash}
            />
          </Suspense>
        </EnvironmentProvider>
      </Sentry.ErrorBoundary>
    </div>
  );
}